import './index.scss'
import Swiper from 'swiper/swiper-bundle.min.js'
$("header .nav ul li").eq(5).addClass("active");  
var showcase = new Swiper(".showcase .swiper", {
    navigation: {
      nextEl: ".showcase .swiper-button-next",
      prevEl: ".showcase .swiper-button-prev",
    },
    loop:true,
     breakpoints: {
      1280: {  //当屏幕宽度小于等于1280
        slidesPerView: 3,
        slidesPerGroup: 3,
        spaceBetween: '1.15%',
      }, 
      320: {  //当屏幕宽度小于等于320
        slidesPerView: 2,
        slidesPerGroup: 2,
        spaceBetween: 10,
      }
    } 
});

